import { memo } from 'react';

import { Button } from '@picsart/design-system/components/Button';
import { IconGenAI } from '@picsart/design-system/foundation/icons/IconGenAI';
import { IconCoins } from '@picsart/design-system/foundation/icons/IconCoins';

import Spinner from '@/components/Spinner';
import usePresetCreditsCost from '@/hooks/usePresetCreditsCost';
import useStyles from './styles';

import type { FeedActionBarProps } from './types';

const FeedActionBar = ({
  label,
  onUpload,
  isDisabled,
  slug,
  shouldLoadCredits,
}: FeedActionBarProps) => {
  const classes = useStyles();
  const { creditsCost, isCreditsCostLoading } = usePresetCreditsCost({
    slug,
    isEnabled: shouldLoadCredits,
  });

  return (
    <div className={classes.actionBar}>
      <Button
        dataTestId="preset-feed-upload-button"
        className={classes.uploadButton}
        variant="filled"
        size="large"
        isFullWidth
        startIcon={IconGenAI}
        onClick={onUpload}
        isDisabled={isDisabled}
      >
        {label}
      </Button>

      {isCreditsCostLoading ? (
        <div className={classes.creditsChip}>
          <Spinner size="small" className={classes.creditsSpinner} />
        </div>
      ) : (
        !!creditsCost &&
        creditsCost > 0 && (
          <div className={classes.creditsChip}>
            <IconCoins className={classes.creditsIcon} fill="currentColor" />
            <span>{creditsCost}</span>
          </div>
        )
      )}
    </div>
  );
};

export default memo(FeedActionBar);
